import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_OPERATIONS_MENU;

const CardOperationMenuLink: Array<LinkItemProps> = [
  {
    name: 'Renouvellement Carte',
    link: URL.CARD_RENEWAL,
    level: 3,
  },
  {
    name: 'Remplacement de carte',
    link: URL.CARD_REPLACEMENT,
    level: 3,
  },
  {
    name: 'Remise à Zéro du Compteur PIN',
    link: URL.PIN_RESET,
    level: 3,
  },
  {
    name: 'Opération de recalcul PIN',
    link: URL.PIN_RECALCULATION_OPERATION,
    level: 3,
  },
  {
    name: 'Changement Mode Renouvellement',
    link: URL.RENEWAL_MODE_CHANGE,
    level: 3,
  },
  {
    name: 'Changement Statut Carte',
    link: URL.CARD_STATUS_CHANGE,
    level: 3,
  },
  {
    name: 'Changement Statut Client',
    link: URL.CUSTOMER_STATUS_CHANGE,
    level: 3,
  },
  {
    name: 'Opposition > Carte',
    link: URL.OPPOSITION,
    level: 3,
  },
  {
    name: 'Adhesion Service Transfert',
    link: URL.SERVICE_TRANSFER_ENROLLMENT,
    level: 3,
  },

];

export default CardOperationMenuLink;
